{
  "product": "Yanxu Enterprise Mail",
  "connecting": "Connecting securely to Yanxu Enterprise Mail",
  "enterpriseSecurity": "Enterprise secure email service",
  "hero": "Secure, clear and efficient\ncommunication",
  "heroText": "Manage company email, calendars, contacts and files in one place, with a smooth experience on every device.",
  "encrypted": "Encrypted in transit · Enterprise data retention",
  "welcome": "Welcome back",
  "loginTitle": "Sign in to Yanxu Enterprise Mail",
  "loginHint": "Continue with your company email account",
  "email": "Email address",
  "password": "Password",
  "passwordPlaceholder": "Enter your email password",
  "totp": "Authenticator code (if enabled)",
  "totpPlaceholder": "6-digit authenticator code",
  "sessionExpiry": "Your secure session expires in 12 hours",
  "forgot": "Forgot password?",
  "login": "Sign in",
  "totpNote": "If TOTP is enabled, enter the authenticator code with your password.",
  "privacy": "© 2026 Yanxu Software · Privacy · Help",
  "showPassword": "Show password",
  "hidePassword": "Hide password",
  "searchGlobal": "Search mail, contacts and attachments",
  "write": "Compose",
  "dashboard": "Mail home",
  "inbox": "Inbox",
  "starred": "Starred",
  "drafts": "Drafts",
  "sent": "Sent",
  "archive": "Archive",
  "junk": "Junk",
  "trash": "Deleted",
  "apps": "Apps",
  "contacts": "Company directory",
  "announcements": "Announcements",
  "attachments": "Attachment center",
  "calendar": "Calendar and meetings",
  "migration": "Import and export",
  "settings": "Personal settings",
  "capacity": "Mailbox storage",
  "pending": "Pending",
  "capacityHint": "Storage usage is provided by the mail engine",
  "toggleTheme": "Toggle light/dark theme",
  "openNav": "Open navigation",
  "logout": "Sign out",
  "search": "Search",
  "all": "All",
  "unread": "Unread",
  "flagged": "Starred",
  "attachment": "Attachments",
  "loadingMail": "Loading mail",
  "viaIMAP": "Retrieving through local encrypted IMAP",
  "readFailed": "Unable to load",
  "missingFolder": "Folder not found",
  "checkSpecial": "Check the MOX special-use folder configuration",
  "emptyMail": "No messages",
  "folderEmpty": "This folder is empty",
  "selectMail": "Select a message to read",
  "secureRead": "Message content is read securely through local encrypted IMAP",
  "back": "Back",
  "delete": "Delete",
  "createEvent": "Create event",
  "reply": "Reply",
  "replyAll": "Reply all",
  "forward": "Forward",
  "download": "Download",
  "adminConsole": "Admin console",
  "announcementAdmin": "Announcement management",
  "storageAdmin": "Storage management",
  "migrationPolicy": "Migration policy",
  "systemAdmin": "System administration",
  "adminConsoleTitle": "Roles, security, retention, audit and service status",
  "refresh": "Refresh",
  "health": "Service status",
  "retention": "Enterprise retention",
  "roles": "Roles and access",
  "security": "Security policy",
  "audit": "Audit log",
  "healthy": "Healthy",
  "needsCheck": "Needs attention",
  "checking": "Checking services",
  "retentionTitle": "Enterprise email retention",
  "retentionDays": "Retention days before releasing the employee copy (blank means forever)",
  "destructionDays": "Final destruction days after archive (blank disables automatic destruction)",
  "trashPolicy": "Visible Trash cleanup",
  "destructionApprovals": "Destruction approvers",
  "oneAdmin": "One administrator",
  "twoAdmins": "Two different administrators",
  "retentionNotice": "Archives are written and SHA-256 verified before an employee copy can be released. Legal hold always blocks destruction.",
  "saveRetention": "Save retention policy",
  "grantRole": "Grant administrator role",
  "existingAccount": "Existing MOX email account",
  "grant": "Grant role",
  "revoke": "Revoke",
  "securityTitle": "Administrator and account security",
  "adminTotp": "Administrators must use TOTP",
  "privilegedRecovery": "Privileged account recovery requires two channels",
  "anomalousRecovery": "Suspicious login recovery requires two channels",
  "normalChannels": "Trusted channels for standard accounts",
  "privilegedChannels": "Trusted channels for privileged accounts",
  "anyOne": "Any one",
  "anyTwo": "Any two",
  "three": "Three",
  "saveSecurity": "Save security policy",
  "auditChain": "Security audit chain",
  "valid": "Verified",
  "invalid": "Verification failed",
  "appearance": "General and appearance",
  "readingList": "Reading and message list",
  "composeDraft": "Compose and drafts",
  "rulesForward": "Rules and forwarding",
  "identitySignature": "Sender identities and signatures",
  "accountSecurity": "Account and security",
  "clientProtocol": "Clients and protocols",
  "dataPrivacy": "Data and privacy",
  "language": "Interface language",
  "simplifiedChinese": "简体中文",
  "english": "English",
  "defaultPage": "Default page after sign-in",
  "dashboardDefault": "Mail home dashboard",
  "desktopLayout": "Desktop mail layout",
  "twoPane": "Two columns",
  "threePane": "Three columns",
  "followSystem": "Follow system",
  "yanxuBlue": "Yanxu blue",
  "lightWhite": "Bright white",
  "darkNight": "Dark night",
  "save": "Save",
  "cancel": "Cancel",
  "close": "Close",
  "enabled": "Enabled",
  "disabled": "Disabled",
  "contactsTitle": "Contacts",
  "contactsSubtitle": "Personal contacts and company directory",
  "newContact": "New contact",
  "searchContacts": "Search name, email, department or company",
  "personalContact": "Personal contact",
  "enterpriseEmployee": "Company employee",
  "emptyContacts": "No contacts",
  "calendarSubtitle": "Personal and shared calendars, invitations and reminders",
  "today": "Today",
  "month": "Month",
  "list": "List",
  "newEvent": "New event",
  "meetingRoom": "Book meeting room",
  "calendarManage": "Calendar management",
  "noEvents": "No events in this range",
  "announcementSubtitle": "Read important company announcements",
  "noAnnouncement": "No company announcements",
  "announcementHint": "Announcements published by administrators appear here",
  "largeFile": "Large-file sharing",
  "largeFileSubtitle": "Create an unguessable link with password, expiry and download limits",
  "chooseFile": "Choose a file to share",
  "createLink": "Create protected link",
  "myLargeFiles": "My large files",
  "migrationSubtitle": "Move mail securely with resumable and cancellable jobs",
  "importMail": "Import mail",
  "exportMail": "Export mail",
  "migrateOld": "Migrate old mailbox",
  "taskHistory": "Job history",
  "noTasks": "No migration jobs",
  "loading": "Loading",
  "saving": "Saving…",
  "saved": "Settings saved",
  "errorGeneric": "Request failed. Try again later.",
  "themeLabel": "Theme",
  "vacationReply": "Vacation auto-reply",
  "settingsSync": "Interface settings follow your account across devices.",
  "settingsSubtitle": "Manage appearance, mail, signatures and account security",
  "listDensity": "Message list density",
  "allowBlockList": "Allow and block lists",
  "mailSubject": "Subject",
  "todaySchedule": "Today's schedule",
  "calendarReminder": "Calendar and meeting reminders",
  "dashboardIndependent": "Live message counts for each folder",
  "dashboardUnread": "Live unread count across all folders",
  "dashboardShortcuts": "Common company mail features",
  "quickAccess": "Quick actions",
  "openInbox": "Open inbox",
  "dragWidgets": "Drag cards to reorder them. Hidden widgets are saved to your account.",
  "syncMailbox": "Syncing mailbox status",
  "overview": "Mailbox overview",
  "unreadMail": "Unread mail",
  "unreadSuffix": "unread messages",
  "refreshData": "Refresh data",
  "refreshJobs": "Refresh jobs",
  "collaborationCalendar": "Shared schedule",
  "noSchedule": "No events",
  "noNotice": "No announcements",
  "adminNotice": "Company announcements published by administrators",
  "companyInfo": "Company information",
  "directoryLabel": "Directory",
  "loadingContacts": "Loading contacts",
  "directorySecure": "Reading securely from the Yanxu directory",
  "createLarge": "Create large-file link",
  "fileControlled": "Files are stored in administrator-controlled storage",
  "expiry": "Expiry",
  "maxDownloads": "Maximum downloads",
  "optionalPassword": "Access password (optional, at least 8 characters)",
  "revokeEarly": "Expire now",
  "largeAttachment": "Large file",
  "dataMigration": "Data migration",
  "fileImport": "Import mail from file",
  "fileSupport": "Supports EML, MBOX and Maildir ZIP. Files are checked for capacity, anomalies and duplicates.",
  "fileFormat": "File format",
  "targetFolder": "Target folder",
  "chooseImport": "Choose import file",
  "createImport": "Create import job",
  "safeRetry": "Failed jobs can be retried safely without importing duplicate messages.",
  "p12Placeholder": "Announcements are scheduled for P12",
  "p13Placeholder": "Calendar is scheduled for P13",
  "currentShares": "Only shares created by this account are shown",
  "emptySubject": "(No subject)",
  "hello": "Hello, ",
  "youHave": "You have",
  "remindersSuffix": "reminders pending",
  "expiryPrefix": "Expires: ",
  "deleted": "Deleted",
  "expired": "Expired",
  "validState": "Active",
  "downloaded": "Downloaded",
  "day1": "Mon",
  "day2": "Tue",
  "day3": "Wed",
  "day4": "Thu",
  "day5": "Fri",
  "day6": "Sat",
  "day7": "Sun",
  "searchMail": "Search mail",
  "searchSubtitle": "Search results open the original message directly",
  "searchResults": "Search results",
  "searchEmpty": "No search results",
  "searchHint": "Search the current folder by keyword",
  "selectResult": "Select a result to view the original message",
  "noMoxJump": "The MOX default page is never opened",
  "saveClose": "Save and close",
  "saveDraft": "Save draft",
  "notSaved": "Not saved",
  "sender": "From",
  "recipient": "To",
  "cc": "Cc",
  "bcc": "Bcc",
  "send": "Send",
  "addAttachment": "Add attachment",
  "plainText": "Plain text",
  "name": "Name",
  "company": "Company",
  "phone": "Phone",
  "position": "Title",
  "department": "Department",
  "notes": "Notes",
  "favoriteContact": "Add to favorites",
  "saveContact": "Save contact",
  "title": "Title",
  "location": "Location",
  "start": "Start",
  "end": "End",
  "reminder": "Reminder",
  "attendeeEmails": "Attendee emails (comma separated)",
  "description": "Description",
  "saveEvent": "Save event",
  "calendarLabel": "Calendar",
  "optional": "(Optional)",
  "mailFileImport": "Mail file import",
  "mailExport": "Mail export",
  "oldIMAP": "Old mailbox IMAP migration",
  "exportMine": "Export my mail",
  "exportNotice": "Only the signed-in employee's folders are exported. The resulting download is available for 24 hours.",
  "exportFormat": "Export format",
  "chooseFolders": "Select folders",
  "exportPassword": "Separate download password",
  "createExport": "Create export job",
  "migrateOther": "Migrate from another mailbox",
  "imapNotice": "Only encrypted IMAPS on port 993 is used. Source credentials are encrypted and destroyed when the job ends.",
  "oldHost": "Source mail server",
  "oldAccount": "Source account",
  "oldPassword": "Source password or app password",
  "continuous": "Continue syncing for a limited time",
  "startMigration": "Start migration",
  "importAllTo": "Import all mail into",
  "tryLabel": "Attempts",
  "completed": "Completed",
  "updatedAt": "· Updated",
  "skipped": "Skipped",
  "imported": "Imported",
  "exported": "Exported",
  "mailSearchLabel": "Mail search",
  "mailboxField": "Email",
  "adminBackend": "Administrator console",
  "announcementManagement": "Company announcement management",
  "announcementPermission": "Only administrators with announcement permission and TOTP can manage announcements.",
  "createAnnouncement": "Create announcement",
  "announcementRecords": "Announcement history",
  "noAnnouncementsYet": "No announcements yet",
  "summary": "Summary",
  "level": "Priority",
  "richBody": "Safe rich-text body",
  "scheduledPublish": "Scheduled publishing",
  "pin": "Pin",
  "largeStoragePolicy": "Large-file storage policy",
  "storageSubtitle": "View the current storage backend and health. Changes take effect after a controlled restart.",
  "currentUse": "Currently in use",
  "localDisk": "Server local disk",
  "synologyNAS": "Synology NAS mount",
  "configurable": "Configurable",
  "healthyStatus": "Status: healthy",
  "nonSensitive": "Non-sensitive runtime settings",
  "localNASDir": "Local or NAS directory",
  "notConfigured": "Not configured",
  "configurationChange": "Configuration changes",
  "restartApplies": "Takes effect after controlled restart",
  "secretWarning": "Access keys and secrets are never returned to the browser or written to audit logs.",
  "migrationAdminTitle": "Import, export and migration policy",
  "migrationAdminSubtitle": "Control export encryption, continuous sync limits and private-network IMAP access.",
  "forceExportPassword": "Require a separate password for every employee export",
  "allowContinuous": "Allow time-limited continuous IMAP sync within administrator limits",
  "continuousMax": "Maximum continuous sync days",
  "allowPrivateIMAP": "Allow private-network IMAP addresses (trusted networks only)",
  "migrationCredentialNotice": "All migrations use IMAPS 993. Source credentials are master-key encrypted and destroyed when the job completes, fails or is cancelled.",
  "savePolicy": "Save policy",
  "systemHealth": "System health",
  "twoChannels": "Two",
  "adminModules": "Administration modules",
  "admin.totp.reset": "Reset TOTP",
  "admin.totp.confirm": "Confirm reset",
  "admin.totp.success": "TOTP reset and all sessions revoked",
  "admin.totp.failure": "Failed to reset TOTP",
  "safeRichText": "Safe rich text",
  "unifiedSignature": "Unified signature",
  "companySignature": "Company signature",
  "signatureAllMail": "Append to every outgoing message",
  "signatureHTMLTemplate": "Safe rich text template",
  "signatureTextTemplate": "Plain text template",
  "signatureAllowImages": "Allow signature images",
  "signatureImageLimit": "Image limit (KB)",
  "signatureImageDimensions": "Maximum image dimensions",
  "signatureHelp": "Supports name, department, title and email variables. Scripts, forms, remote CSS, frames and unsafe HTML are filtered.",
  "signatureSave": "Save company signature",
  "signatureSaved": "Company signature saved",
  "totpReset": "Reset TOTP",
  "announcementSelect": "Select an announcement to view details",
  "important": "Important",
  "adminNative1": "All states",
  "adminNative2": "Failed",
  "adminNative3": "Not checked",
  "adminNative4": "Cancelled",
  "adminNative5": "No matching delivery jobs",
  "adminNative6": "No delivery attempts",
  "adminNative7": "Delivering",
  "adminNative8": "Queued",
  "adminNative9": "Recipient domain",
  "adminNative10": "Filter",
  "adminNative11": "Mail operations center",
  "adminNative12": "IP / network",
  "adminNative13": "Allow",
  "adminNative14": "Allow / deny rules",
  "adminNative15": "Creation failed",
  "adminNative16": "Create rule",
  "adminNative17": "Safe to download",
  "adminNative18": "Address",
  "adminNative19": "Domain",
  "adminNative20": "Approval failed",
  "adminNative21": "Download blocked",
  "adminNative22": "No quarantined mail awaiting review",
  "adminNative23": "Deny",
  "adminNative24": "Revocation failed",
  "adminNative25": "Operation failed",
  "adminNative26": "Unable to load security data",
  "adminNative27": "Preview unavailable",
  "adminNative28": "Reason for this operation (audited)",
  "adminNative29": "Independent approval",
  "adminNative30": "Hide from the administration view?",
  "adminNative31": "Revoke this rule?",
  "adminNative32": "Release to the employee inbox?",
  "adminNative33": "Administrator security review",
  "adminNative34": "Rule target",
  "adminNative35": "Select a message to view its filtered safe preview",
  "adminNative36": "Mail quarantine and security rules",
  "adminNative37": "Release",
  "adminNative38": "Hide",
  "adminNative39": "Quarantined mail",
  "adminNative40": "Require approval by a second administrator",
  "adminNative41": "DKIM keys and rotation",
  "adminNative42": "DKIM key rotation",
  "adminNative43": "Reason for change (security audited)",
  "adminNative44": "Activation failed",
  "adminNative45": "Activate key",
  "adminNative46": "Retired",
  "adminNative47": "Pending activation",
  "adminNative48": "New selector",
  "adminNative49": "Unable to load DKIM keys",
  "adminNative50": "Unable to load domains",
  "adminNative51": "Update failed",
  "adminNative52": "Mark DNS verified",
  "adminNative53": "Mark DNS invalid",
  "adminNative54": "Generate next key",
  "adminNative55": "Generation failed",
  "adminNative56": "Private keys remain encrypted on the server. The UI and API only show the DNS TXT record to publish.",
  "adminNative57": "Mail domain",
  "adminNative58": "15 days",
  "adminNative59": "30 days",
  "adminNative60": "60 days",
  "adminNative61": "7 days",
  "adminNative62": "90 days",
  "adminNative63": "DKIM keys",
  "adminNative64": "Enterprise retention policy saved",
  "adminNative65": "Save failed",
  "adminNative66": "Company signature rich text template",
  "adminNative67": "Company signature plain text template",
  "adminNative68": "Security policy saved",
  "adminNative69": "Unhealthy",
  "adminNative70": "Grant failed",
  "adminNative71": "Unable to load administration data",
  "adminNative72": "Permanent",
  "adminNative73": "Maximum signature image width",
  "adminNative74": "Maximum signature image height",
  "adminNative75": "Operations",
  "adminNative76": "Quarantine and rules",
  "adminNative77": "Accounts and aliases",
  "adminNativeExtra1": "DNS status",
  "adminNativeExtra2": "TLS certificates",
  "adminNativeExtra3": "TLS certificate status",
  "adminNativeExtra4": "Close details",
  "adminNativeExtra5": "Cancel delivery task",
  "adminNativeExtra6": "Domains, DNS and certificates",
  "adminNativeExtra7": "Certificate subject unavailable",
  "adminNativeExtra8": "No domain DNS results",
  "adminNativeExtra9": "No configured certificates",
  "adminNativeExtra10": "Delivery tasks",
  "adminNativeExtra11": "Delivery task details",
  "adminNativeExtra12": "Delivery logs",
  "adminNativeExtra13": "Delivery queue",
  "adminNativeExtra14": "Reason",
  "adminNativeExtra15": "No expiry",
  "adminNativeExtra16": "View details",
  "adminNativeExtra17": "Loading…",
  "adminNativeExtra18": "Submitting…",
  "adminNativeExtra19": "No recipient records",
  "adminNativeExtra20": "Status",
  "adminNativeExtra21": "Confirm cancellation",
  "adminNativeExtra22": "Confirm",
  "adminNativeExtra23": "Confirm recipient retry",
  "adminNativeExtra24": "Filter delivery queue",
  "adminNativeExtra25": "This action is recorded in the security audit log. Enter a reason.",
  "adminNativeExtra26": "Operations pages",
  "adminNativeExtra27": "Retry",
  "connectionOffline": "Offline",
  "task10UI1": "Created shares will appear here",
  "task10UI2": "Check mail",
  "task10UI3": "Real progress will appear here after creating a task",
  "task10UI4": "No large files yet",
  "task10UI5": "Mailbox status is temporarily unavailable",
  "task10UI6": "Detecting mail folders",
  "task10UI7": "Check the system folder configuration",
  "task10UI8": "Open original message through JMAP",
  "task10UI9": "Message content is read securely through JMAP",
  "等待 worker 处理": "Waiting for background worker",
  "quota.loading": "Loading",
  "quota.loadingDetail": "Loading quota data",
  "dataPrivacy.loading": "Loading data policy"
}
